import type { BaseAPI } from '@xpanse/organization-service-client';

import { useXpanseAuth } from '@/hooks/useXpanseAuthentication';

export const useWithPreMiddleWare = <T extends BaseAPI>(api: T) => {
  const { idToken } = useXpanseAuth();
  return api.withPreMiddleware<T>(async (context) => {
    const headers = new Headers(context.init.headers);
    const token = await idToken();

    headers.set('Authorization', `Bearer ${token}`);
    context.init.headers = headers;

    return context;
  });
};
